import { REFERENCES } from "@/lib/site-data";
import useSeo from "@/lib/useSeo";

export default function References() {
  useSeo({
    title: "Referanslarımız | Epersonel",
    description:
      "Farklı sektörlerdeki işyerlerinin dijital satış kanallarını kuruyor, geliştiriyor ve yönetiyoruz. Çözüm sunduğumuz Üye İşyerlerinden bazıları.",
  });
  return (
    <>
      <section className="pt-16 pb-8">
        <div className="ep-container max-w-4xl">
          <p className="text-xs tracking-[0.3em] text-[#00F22E] font-semibold mb-4">
            REFERANSLARIMIZ
          </p>
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight">
            Çözüm Sunduğumuz Üye İşyerlerinden Bazıları
          </h1>
          <p className="mt-5 text-white/80 text-base md:text-lg leading-relaxed">
            Farklı sektörlerdeki işyerlerinin dijital satış kanallarını kuruyor,
            geliştiriyor ve yönetiyoruz.
          </p>
        </div>
      </section>
      <section className="py-12">
        <div className="ep-container">
          <div
            className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6"
            data-testid="references-grid"
          >
            {REFERENCES.map((r, i) => (
              <div
                key={i}
                data-testid={`references-page-${i}`}
                className="ep-ref-card"
              >
                <img
                  src={r.src}
                  alt={`${r.name} logosu`}
                  loading="lazy"
                  width="300"
                  height="200"
                />
              </div>
            ))}
          </div>
          <p className="mt-10 text-sm text-white/75 max-w-3xl leading-relaxed">
            Gösterilen bazı markalar bağımsız şube veya franchise Üye İşyerleri
            üzerinden temsil edilmektedir. Marka ve logolar ilgili hak
            sahiplerine aittir.
          </p>
        </div>
      </section>
    </>
  );
}
